// src/views/admin/memberDetail/component/AddCardModal.js

import React, { useEffect, useState } from "react";
import { Modal, notification, Spin } from "antd";
import AddCardForm from "views/payment/stripe/AddCardForm";
import { Controller } from "Controller/Controller";
// Removed Alert import as it's now handled inside AddCardForm

const AddCardModal = ({ open, close, memberId, onCardAdded }) => {
  // Add onCardAdded prop
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);

  const createSetupIntent = async () => {
    if (!memberId) return;
    setLoading(true);
    setClientSecret(null); // Reset previous secret
    try {
      const response = await Controller.getClientSecret(memberId);
      if (response.status < 250) {
        setClientSecret(response.json.client_secret);
      } else {
        // Handle error case
        notification.error({
          message: "Error",
          description: "Could not initialize the card form. Please try again.",
          placement: "bottom",
        });
        close(); // Close modal on critical error
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "A network error occurred. Please try again.",
        placement: "bottom",
      });
      close();
    } finally {
      setLoading(false);
    }
  };

  // IMPORTANT FIX: This useEffect now depends on `open` and `memberId`
  // It will run whenever the modal is opened.
  useEffect(() => {
    if (open) {
      createSetupIntent();
    }
  }, [open, memberId]);

  const handleSuccess = () => {
    notification.success({
      message: "Success",
      description: "The new card has been added successfully.",
      placement: "bottom",
    });
    if (onCardAdded) {
      onCardAdded(); // This will trigger a refresh in the parent component
    }
    close(); // Close the modal
  };

  const handleError = (message) => {
    // Notification is already shown inside the form,
    // so you might not need another one here unless you want to.
    console.error("Failed to add card:", message);
  };

  return (
    <Modal
      title={"Add New Card"}
      open={open} // Use `open` instead of `visible` for modern antd
      footer={null}
      onCancel={close}
      destroyOnClose={true} // Good practice to reset state on close
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin tip="Initializing..." />
        </div>
      ) : (
        <AddCardForm
          clientSecret={clientSecret}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      )}
    </Modal>
  );
};

export default AddCardModal;
